import type { ZeytalCLIPureConfig } from "@zeytal/kit";
import type { FigmaRestApi, ZeytalTokens } from "@zeytal/types";

import { createBlur } from "./blur.ts";
import { createDropShadow } from "./drop-shadow.ts";
import { createInnerShadow } from "./inner-shadow.ts";

export const effectMaker = (
  stylesFormatsConfig: ZeytalCLIPureConfig["styles"]["formats"],
  effectValues: FigmaRestApi.Effect[],
) => {
  // Only handle single paint value styles.
  const value = {} as ZeytalTokens.EffectStyleValue;
  const { combine } = stylesFormatsConfig.effects;

  effectValues.forEach((effect) => {
    // Prepare shadow property w/ or w/o combination
    if (
      !value.shadow &&
      (effect.type === "INNER_SHADOW" || effect.type === "DROP_SHADOW")
    ) {
      value.shadow = combine ? "" : [];
    }

    // Add to shadow string if combination
    if (
      stylesFormatsConfig.effects.combine &&
      (effect.type === "INNER_SHADOW" || effect.type === "DROP_SHADOW")
    ) {
      value.shadow += value.shadow ? ", " : "";
    }

    // Handle effects types making
    if (effect.type === "INNER_SHADOW") {
      if (!combine && Array.isArray(value.shadow)) {
        value.shadow.push(createInnerShadow(stylesFormatsConfig, effect));
      } else {
        value.shadow += createInnerShadow(stylesFormatsConfig, effect);
      }
    } else if (effect.type === "DROP_SHADOW") {
      if (!combine && Array.isArray(value.shadow)) {
        value.shadow.push(createDropShadow(stylesFormatsConfig, effect));
      } else {
        value.shadow += createDropShadow(stylesFormatsConfig, effect);
      }
    } else if (effect.type === "LAYER_BLUR") {
      value.layerBlur = createBlur(stylesFormatsConfig, effect);
    } else if (effect.type === "BACKGROUND_BLUR") {
      value.backgroundBlur = createBlur(stylesFormatsConfig, effect);
    }
  });

  // If no shadow combination and only one shadow, return a string instead of an array of one string
  if (
    value.shadow &&
    Array.isArray(value.shadow) &&
    value.shadow.length === 1
  ) {
    value.shadow = value.shadow[0];
  }

  return value;
};
